export default __webpack_public_path__ + "static/BudapestJS_logo@2x-075590f577b77dac305f96c7f536a0dc.png";